import { ConfigColor } from "./config-color";
import { ColorGenerator } from "../utils/_index";
import { Traducible } from "./traducible";

export class Segmentacion {
	idSegmentacion: number = -1;
	nombreDes: Traducible;
	color: ConfigColor = new ConfigColor();
	idCliente: number;
	activo: boolean;
	codigo: string;
	nombre: string;

	colorGenerator: ColorGenerator = new ColorGenerator();

	constructor(params = null) {
		if (params) {
			this.idSegmentacion	= params.idSegmentacion;
			this.nombreDes		= params.nombreDes;
			this.idCliente		= params.idCliente;
			this.activo			= params.activo;
			this.codigo			= params.codigo;
			this.nombre			= params.nombre;
		}
		this.color = this.colorGenerator.generarColorHexAleatorio();
	}
}